// extracted by mini-css-extract-plugin
export default {"container":"page404_container__UJuY1","action":"page404_action__0n1le"};